// extracted by mini-css-extract-plugin
export default {"customSwitch":"components_customSwitch__1TTwm"};